import React, { useState } from "react";
import './HomePage.css'; // Import custom CSS
import backgroundImage from '../assets/image/backg.png'; // Import the local background image
import back1 from '../assets/image/back1.jpg';
import back3 from '../assets/image/back3.jpg';
import product1 from '../assets/image/product1.png'; // Import the new product image
import product2 from '../assets/image/product2.jpg'; // Import the new product image
import product3 from '../assets/image/product3.jpg'; // Import the new product image
import product4 from '../assets/image/product4.jpg';
import product5 from '../assets/image/product5.jpg';
import product6 from '../assets/image/product6.jpg';
import product7 from '../assets/image/product7.jpg';
import product8 from '../assets/image/product8.jpg';


const HomePage = () => {
  const [activeCategory, setActiveCategory] = useState("Top Products");

  const products = [
    {
      id: 1,
      name: "MS Plate",
      category: "Top Products",
      price: "LKR 1000",
      description: "A high-quality product for your business needs.",
      image: product2,
    },
    {
      id: 2,
      name: "Safety Equipment",
      category: "Top Products",
      price: "LKR 1120",
      description: "A premium quality product for your business.",
      image: product7,
    },
    {
      id: 3,
      name: "Steam Pipes",
      category: "Top Products",
      price: "LKR 1110",
      description: "The best in the market for your needs.",
      image: product4,
    },
    {
      id: 4,
      name: "Fittings & Valves",
      category: "Top Products",
      price: "$130",
      description: "Top-rated product with excellent reviews.",
      image: product5,
    },
    {
      id: 5,
      name: "Welding Equipment",
      category: "Best Sale",
      price: "LKR 880",
      description: "A top-selling product with amazing features.",
      image: product6,
    },
    {
      id: 6,
      name: "GI pipes and fittings",
      category: "Best Sale",
      price: "LKR 385",
      description: "An affordable and high-quality product.",
      image: product3, // Add your actual image here
    },
    {
      id: 7,
      name: "Engineering Power Tools",
      category: "Best Sale",
      price: "LKR 990",
      description: "A best-seller with unbeatable value.",
      image: product8, // Add your actual image here
    },
    {
      id: 16,
      name: "GI pipes and fittings",
      category: "Best Sale",
      price: "LKR 9080",
      description: "A top-selling product with amazing features.",
      image: product8, // Add your actual image here
    },
    {
      id: 8,
      name: "Featured 1",
      category: "Featured",
      price: "LKR 120",
      description: "Premium quality product featured for you.",
      image: product3, // Add your actual image here
    },
    {
      id: 9,
      name: "Featured 2",
      category: "Featured",
      price: "LKR 130",
      description: "Another premium featured product.",
      image: product1, // Add your actual image here
    },
    {
      id: 10,
      name: "Featured 3",
      category: "Featured",
      price: "LKR 140",
      description: "Top-rated featured product with amazing reviews.",
      image: product4, // Add your actual image here
    },
    {
      id: 15,
      name: "Featured 3",
      category: "Featured",
      price: "LKR 140",
      description: "Top-rated featured product with amazing reviews.",
      image: product7, // Add your actual image here
    },
    {
      id: 11,
      name: "New Arrivals 1",
      category: "New Arrivals",
      price: "$90",
      description: "Fresh new products just arrived in the store.",
      image: product1, // Updated with the new local product image
    },
    {
      id: 12,
      name: "New Arrivals 2",
      category: "New Arrivals",
      price: "LKR 110",
      description: "A new exciting product for your collection.",
      image: product1, // New product image
    },
    {
      id: 13,
      name: "New Arrivals 3",
      category: "New Arrivals",
      price: "LKR 130",
      description: "Another fantastic product for your business needs.",
      image: product4, // New product image
    },
    {
      id: 14,
      name: "New Arrivals 4",
      category: "New Arrivals",
      price: "LKR 150",
      description: "An advanced version of our popular product.",
      image: product1, // Same image as Product 1 for demo purposes
    },
  ];

  const categories = ["Top Products", "Best Sale", "Featured", "New Arrivals"];

  const filteredProducts = products.filter(
    (product) => product.category === activeCategory
  );

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section
        className="hero-section"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="hero-text">
          <h1>Welcome to Atlas Trade Center</h1>
          <p>Your trusted partner in providing high-quality products and services that help businesses grow.</p>
          <a href="/shop" className="btn-primary">Shop Now</a>
        </div>
      </section>

      {/* Featured Services Section */}
      <section className="feature-services">
        <h2>Our Featured Services</h2>
        <div className="service-list">
          <div className="service-item">
            <img src={back1} alt="Product Solutions" />
            <h3>Product Solutions</h3>
            <p>We offer a variety of products that are tailored to meet your business needs.</p>
          </div>
          <div className="service-item">
            <img src={back3} alt="Consulting" />
            <h3>Consulting</h3>
            <p>Expert consulting to help you grow and scale your business with efficiency.</p>
          </div>
          <div className="service-item">
            <img src={back1} alt="Customer Support" />
            <h3>Customer Support</h3>
            <p>We provide ongoing support to ensure your business is always running smoothly.</p>
          </div>
        </div>
        <a href="http://localhost:3001/about" className="btn-primary">Learn More About Our Services</a>
      </section>

      {/* Product Section */}
      <section className="product-section">
        <h2>Our Products</h2>
        <div className="category-filter">
          {categories.map((category) => (
            <button
              key={category}
              className={`category-button ${activeCategory === category ? "active" : ""}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>
        <div className="product-list">
          {filteredProducts.map((product) => (
            <div key={product.id} className="product-card">
              <img src={product.image} alt={product.name} />
              <h3>{product.name}</h3>
              <p>{product.description}</p>
              <p className="price">{product.price}</p>
              <button className="btn-primary">Add to Cart</button>
            </div>
          ))}
        </div>
      </section>

      {/* Feedback Section */}
      <section className="feedback-section">
  <h2>What Our Clients Say</h2>
  <div className="feedback-list">
    <div className="feedback-item">
      <div className="feedback-avatar">
        <img src={require('../assets/image/person1.jpg')} alt="A.W.S Sumathipala" />
      </div>
      <p className="feedback-text">"Fantastic service! The products exceeded my expectations and the support team was very responsive. Will definitely be back!"</p>
      <div className="feedback-info">
        <cite>- A.W.S Sumathipala</cite>
        <div className="rating">
          <span className="star">&#9733;</span>
          <span className="star">&#9733;</span>
          <span className="star">&#9733;</span>
          <span className="star">&#9733;</span>
          <span className="star">&#9734;</span>
        </div>
      </div>
    </div>

    <div className="feedback-item">
      <div className="feedback-avatar">
        <img src={require('../assets/image/person2.jpg')} alt="A.B Smith" />
      </div>
      <p className="feedback-text">"I can't recommend this company enough! Quick delivery and high-quality products that have really helped my business grow."</p>
      <div className="feedback-info">
        <cite>- A.B Smith</cite>
        <div className="rating">
          <span className="star">&#9733;</span>
          <span className="star">&#9733;</span>
          <span className="star">&#9733;</span>
          <span className="star">&#9734;</span>
          <span className="star">&#9734;</span>
        </div>
      </div>
    </div>

    <div className="feedback-item">
      <div className="feedback-avatar">
        <img src={require('../assets/image/person3.jpg')} alt="W.S. Perera" />
      </div>
      <p className="feedback-text">"Great quality and customer service! The Atlas Trade Center team really cares about their customers."</p>
      <div className="feedback-info">
        <cite>- W.S. Perera</cite>
        <div className="rating">
          <span className="star">&#9733;</span>
          <span className="star">&#9733;</span>
          <span className="star">&#9733;</span>
          <span className="star">&#9733;</span>
          <span className="star">&#9733;</span>
        </div>
      </div>
    </div>
  </div>
</section>

    </div>
  );
};

export default HomePage;
